import { DessertsCard } from "../MenuCard/DessertsCard";
import { MenuCard } from "../MenuCard/MenuCard";
import { MenuList } from "../MenuCard/MenuList";
import { ReadOnlyMenuList } from "../MenuCard/ReadOnlyMenuList";
import { SchoolHolidayIndicator } from "../SchoolHolidayIndicator";
export const WeeklyGridMenuCard = ({ menuData, weekIndex, dayKey, isReadOnly, isSchoolHoliday, onMenuToggle, invalid, selectedMenuIds = [], isDisabled = false, }) => {
    return (<MenuCard dayNumber={menuData.dayNumber} hasCheckmark={menuData.menus.some((menu) => selectedMenuIds.includes(Number(menu.id)))} invalid={invalid}>
      {isSchoolHoliday && <SchoolHolidayIndicator />}

      {isReadOnly || isDisabled ? (<ReadOnlyMenuList menus={menuData.menus} selectedMenuIds={selectedMenuIds}/>) : (<MenuList menus={menuData.menus} onMenuToggle={(id) => onMenuToggle(weekIndex, dayKey, id)}/>)}

      <DessertsCard desserts={menuData.desserts}/>
    </MenuCard>);
};
//# sourceMappingURL=WeeklyGridMenuCard.js.map